function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.399 5.111a6.807 6.807 0 10-6.588 8.506h5.384a4.338 4.338 0 001.2-8.506zm-1.2 7.279H6.808a5.581 5.581 0 115.543-6.217 3.11 3.11 0 01-.155 6.217z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.195 7.448h-1.08v-.639a4.3 4.3 0 10-4.3 4.3h5.384a1.832 1.832 0 100-3.664"
});

var SvgPtWhiteIcon = function SvgPtWhiteIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16.534 13.617"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi41MzQgMTMuNjE3Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDA4OSAtMTQ4NDYuNSkiPjxwYXRoIGQ9Ik0zNjkuOTkxLDUuMTExYTYuODA3LDYuODA3LDAsMSwwLTYuNTg4LDguNTA2aDUuMzg0YTQuMzM4LDQuMzM4LDAsMCwwLDEuMi04LjUwNlptLTEuMiw3LjI3OUgzNjMuNGE1LjU4MSw1LjU4MSwwLDEsMSw1LjU0My02LjIxN2gwYTMuMTEsMy4xMSwwLDAsMS0uMTU1LDYuMjE3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzczMi40MDggMTQ4NDYuNSkiLz48cGF0aCBkPSJNMzc5LjUyOCwxOC4xODdoLTEuMDh2LS42MzlhNC4zLDQuMywwLDEsMC00LjMsNC4zaDUuMzg0YTEuODMyLDEuODMyLDAsMSwwLDAtMy42NjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3MjEuNjY3IDE0ODM1Ljc2MSkiLz48L2c+PC9zdmc+";
export { SvgPtWhiteIcon as ReactComponent };